// @flow
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Formik } from 'formik';
import * as sidePanelActionCreators from 'esm-web-pro/redux/side-panel/actions';
import ApiForm from 'esm-web-pro/containers/forms/ApiForm';

type Props = {
    point14: Object,
    onSave: Function,
    onClose: Function,
    resource: string,
    updateObject: Function,
};


@withRouter
@connect(null, (dispatch) => (bindActionCreators(sidePanelActionCreators, dispatch)))
class Point14Editor extends React.Component<Props> {
    formRef: { current: null | React.ElementRef<Formik> } = null;

    constructor(props: Props) {
        super(props);
        this.formRef = React.createRef();
    }

    handleSave = (response: Object) => {
        const { onSave, updateObject } = this.props;
        onSave(response);
        updateObject(response);
    };

    handleCancel = () => {
        const { onClose } = this.props;
        onClose();
    };

    handleSubmit = (values: Object) => ({ ...values, container: values.container.id, attenuation: values.attenuation });

    render() {
        const {
            point14, resource,
        } = this.props;

        return (
            <>
                <ApiForm
                    forwardRef={this.formRef}
                    resourceName={resource}
                    objectId={point14.uuid}
                    excludeFields={['container', 'model', 'stage', 'physical_circuit']}
                    onSave={this.handleSave}
                    onClose={this.handleCancel}
                    onSubmit={this.handleSubmit}
                    height="100%"
                    partialUpdate
                />
            </>
        );
    }
}

export default Point14Editor;
